import { useEffect } from "react";
import PropTypes from "prop-types";

import Icon from "components/ShellV2/Icon";

/* Centered confirmation dialog (port of the design's ConfirmDialog): a tinted
   icon, title, body and cancel/confirm actions. `danger` styles it red. */
export default function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  danger,
  icon,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onCancel?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;
  const ic = icon || (danger ? "warning" : "help");

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <div
      className="rec-modal-scrim"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel?.();
      }}
    >
      <div className="rec-modal" role="alertdialog" aria-modal="true" style={{ maxWidth: 432 }}>
        <div className={`rec-confirm-ic ${danger ? "danger" : "accent"}`}>
          <Icon name={ic} fill />
        </div>
        {title && <h3>{title}</h3>}
        {body && <p>{body}</p>}
        <div className="rec-modal-foot mt-[22px]">
          <button type="button" className="rec-btn-ghost" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={danger ? "rec-btn-danger" : "rec-btn-primary"}
            onClick={onConfirm}
          >
            <Icon name={danger ? "delete" : "check"} />
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.node,
  body: PropTypes.node,
  confirmLabel: PropTypes.node,
  cancelLabel: PropTypes.node,
  danger: PropTypes.bool,
  icon: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};

ConfirmDialog.defaultProps = {
  open: false,
  title: null,
  body: null,
  confirmLabel: "Confirmar",
  cancelLabel: "Cancelar",
  danger: true,
  icon: undefined,
  onConfirm: undefined,
  onCancel: undefined,
};
